import { render, staticRenderFns } from "./fbCode.vue?vue&type=template&id=57648ab0&"
import script from "./fbCode.vue?vue&type=script&lang=js&"
export * from "./fbCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports